import styled from 'styled-components';
import { getSiteColor } from '../../utils/getSiteColor';
import { breakpoints } from '@chegg-ui/theme';
export var ThankYouPanel = styled.div.withConfig({
  componentId: "sc-89nnw2-0"
})(["color:#000000;font-family:Aspira,Helvetica,Arimo,'Liberation Sans',Arial,sans-serif;font-weight:bold;line-height:38px;text-align:center;font-size:38px;"]);
export var ReturnToPaperButton = styled.div.withConfig({
  componentId: "sc-89nnw2-1"
})(["background-color:", ";border-radius:12px;text-align:center;color:white;font-size:20px;cursor:pointer;margin:30px auto 0;line-height:48px;width:288px;max-width:100%;font-family:Aspira,Helvetica,Arimo,'Liberation Sans',Arial,sans-serif;@media screen and (max-width:", "px){width:288px;margin:24px auto 43px;}@media screen and (min-width:", "px){width:340px;margin:40px auto 28px;}@media screen and (max-height:", "px){width:288px;margin:24px auto 43px;}"], function (_ref) {
  var siteName = _ref.siteName;
  return getSiteColor(siteName);
}, breakpoints.lg.min, breakpoints.lg.min, breakpoints.md.min);
export var SuccessContentWrapper = styled.div.withConfig({
  componentId: "sc-89nnw2-2"
})(["height:fit-content;display:flex;flex-direction:column;position:relative;padding:36px;background:#ffffff;"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/components/SuccessContent/styled.js
// module id = 5229
// module chunks = 11